import { Option } from "@modules/elements/types/option";
import { RecordDeliverableDestination, RecordDeliverableFormat, RecordDuration, RecordStartTrigger } from "./record";
import { Frequency, RRule, Weekday } from "rrule";
import { Timezone } from "@modules/elements/types/timezone";

export class RecordOptions {

  public frequency: Option<Frequency>[] = [
    new Option(Frequency.DAILY, 'Daily'),
    new Option(Frequency.WEEKLY, 'Weekly'),
    new Option(Frequency.MONTHLY, 'Monthly'),
  ];

  public weekdays: Option<Weekday>[] = [
    new Option(RRule.MO, 'Monday'),
    new Option(RRule.TU, 'Tuesday'),
    new Option(RRule.WE, 'Wednesday'),
    new Option(RRule.TH, 'Thursday'),
    new Option(RRule.FR, 'Friday'),
    new Option(RRule.SA, 'Saturday'),
    new Option(RRule.SU, 'Sunday'),
  ];

  public startTrigger: Option<RecordStartTrigger>[] = [
    new Option('manual', 'Manual'),
    new Option('startTime', 'Start Time'),
    new Option('scteTrigger', 'SCTE Trigger'),
    // new Option('timecode', 'Timecode'),
  ];

  public duration: Option<RecordDuration>[] = [
    new Option('seconds', 'Minutes'),
    // new Option('frames', 'Frames'),
    // new Option('timecode', 'Timecode'),
  ];

  public deliverableFormat: Option<RecordDeliverableFormat>[] = [
    new Option('j2kp', 'J2K (Progressive)'),
    new Option('j2ki', 'J2K (Interlaced)'),
    new Option('xdcam', 'XDCAM'),
    new Option('dnx', 'DNX'),
    new Option('h264', 'H264'),
    new Option('ts', 'TS'),
    new Option('no_video_only_cc', 'No Video (Only CC)'),
  ];

  public destinationFlags: Option<string>[] = [
    new Option('', ''),
    new Option('bucket-owner-full-control', 'ACL')
  ];

  public defaultDestinations: string[] = [
    // Bill Maher
    'vod',
    'max',
    'maxChimera',
    'linear',
    'contentAcquisition',
    'archive',
    // C3
    'c3',
    // Cinedeck
    'logs',
    'backup',
    'cinedeck',
  ]

  public timezones: Option<string>[] = Timezone.options().map(option => new Option(option.tzCode, option.name));

  public additionalMetadataDefaultKeys: string[] = [
    'Inventory ID',
    'EE Master ID',
    'Reporting Title', 
    'SCRID',
    'Filename',
    'NetworkID',
    'WBID',
    'MPM',
    'ARCHIVE_FILENAME', 
    'MatID',
    'c3_primary_filename',
    'c3_primary_folder',
    'c3_primary_material_id',
    'c3_secondary_filename',
    'c3_secondary_folder',
    'c3_secondary_material_id',
    'selfHostedPrimaryName',
    'selfHostedBackupName',
  ];
  // General
  public metadataGeneralDefaultKeys: string[] = ['Filename'];
  // VOD and MAX
  public metadataVodAndMaxDefaultKeys: string[] = ['Inventory ID', 'EE Master ID'];
  public metadataVodDefaultKeys: string[] = ['Inventory ID', 'EE Master ID', 'Reporting Title'];
  public metadataMaxDefaultKeys: string[] = ['SCRID', 'MAX_UUID'];
  // Linear
  public metadataLinearDefaultKeys: string[] = ['MaterialId'];
  // Archive
  public metadataArchiveDefaultKeys: string[] = ['WBID', 'MPM', 'ARCHIVE_FILENAME'];
  // C3
  public metadataC3DefaultKeys: string[] = [
    'c3_primary_filename',
    'c3_primary_folder',
    'c3_primary_material_id',
    'STATION_NAME'
  ];
  // Content Acquisition
  public metadataContentAcquisitionDefaultKeys: string[] = [
    'contentAcquisitionFileName'
  ]
  // S3 Download
  public metadataS3DownloadDefaultKeys: string[] = [
    'downloadS3Link'
  ];

  public metadataC3BackupDefaultKeys: string[] = [
    'c3_secondary_filename',
    'c3_secondary_folder',
    'c3_secondary_material_id',
  ];

  public metadataHudsonYardsDefaultKeys: string[] = [
    'selfHostedPrimaryName',
    'selfHostedBackupName',
  ];

  // Titles
  public overrideMetadataKeys: {[key: string]: string} = {
    'SCRID': 'Edit SCRID',
    'MAX_UUID': 'UUID',
    'ARCHIVE_FILENAME': 'Filename',
    'c3_primary_filename': 'Filename',
    'c3_primary_folder': 'Folder',
    'c3_primary_material_id': 'PAID',
    'c3_secondary_filename': 'Backup Filename',
    'c3_secondary_folder': 'Backup Folder',
    'c3_secondary_material_id': 'Backup PAID',
    'selfHostedPrimaryName': 'Self-Hosted Name',
    'selfHostedBackupName': 'Backup Self-Hosted Name',
    'MaterialId': 'PAID',
    'contentAcquisitionFileName': 'Filename',
    'downloadS3Link': 'URL'
  };

}